import clsx from "clsx";

export const TimeSlotSection = ({
  currentSlots,
  selectedSlots,
  dispatch,
  state,
  maxSelections = 1,
}) => {
  if (!state.calendarValues.selectedDate) {
    return (
      <p className="pl-7 text-sm text-muted">
        Επίλεξε πρώτα ημερομηνία
      </p>
    );
  }

  const dateKey = state?.calendarValues?.selectedDate.toLocaleDateString('en-CA');
  // Convert backend slots → slot windows
  const slotWindows = currentSlots.map((slot) => {
    const start = new Date(slot.startTime);
    const end = new Date(slot.endTime);
    return {
        date: dateKey,
        start: start.toLocaleTimeString("el-GR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        }),
        end: end.toLocaleTimeString("el-GR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        }),
    };
  });

  const isSelected = (slot) =>
    selectedSlots.some(
      s =>
        s.date === slot.date &&
        s.start === slot.start &&
        s.end === slot.end
    );
    

  return (
    <div className="pl-7 grid grid-cols-1 gap-3 overflow-y-auto">
      {slotWindows.map((slot, idx) => {
        const selected = isSelected(slot);

        return (
            <div
                key={idx}
                onClick={() =>{
                    if(!selected) {
                      state?.calendarValues?.selectedSlots?.length < maxSelections &&
                      dispatch({
                          type: "ADD_TIMESLOT",
                          value: slot,
                      })
                      if(maxSelections === 1 && state?.calendarValues?.selectedSlots?.length === 1) {
                        dispatch({
                          type: "REMOVE_TIMESLOT",
                          value: state?.calendarValues?.selectedSlots?.[0],
                        }) 
                        dispatch({
                          type: "ADD_TIMESLOT",
                          value: slot,
                        }) 
                      }
                    }
                  }
                }
                className={clsx(
                "rounded-full flex justify-center py-1",
                "cursor-pointer border border-fadedgrey text-black",
                selected &&
                    "text-white cursor-auto border-[#D4002A] bg-[#D4002A]"
                )}
            >
                {slot.start} – {slot.end}
            </div>
        );
      })}
    </div>
  );
};